// extracted by css-extract-rspack-plugin
export default {"form":"iNTRPVatd0M9Ns3O__form___","formActions":"YpoDQrFt3YsP5mCh__formActions___"};